import { BasicRequest } from "./basicRequest";

export class DeleteFileDefinitionRequest extends BasicRequest{
    public fileDefinitionId! : number;
    public physicalDelete : boolean = false;
}